import { useCallback } from "react"
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import classnames from "classnames"

import { SubscriptionDialog } from "./subscription-dialog"
import { SubscriptionForm } from "./subscription-form"

interface SubscriptionProps {
  className?: string
}

export const Subscription = observer(function Subscription(
  props: SubscriptionProps,
) {
  const { GlobalModel, ModalModel, AnalyticsModel } = useStore()
  const { className } = props
  const { journalFooterForm } =
    GlobalModel.featureToggles.emailSubscription || {}

  const submitCallback = useCallback(
    function submitCallback() {
      ModalModel.open(<SubscriptionDialog success={true} />)
      AnalyticsModel.subscribeFooterSubmitClick()
    },
    [ModalModel, AnalyticsModel],
  )

  if (!journalFooterForm) {
    return null
  }

  return (
    <section
      className={classnames("container py-12.5 tablet:py-20", className)}
    >
      <div className="flex justify-center">
        <SubscriptionForm
          classes={{
            title: "text-xl desktop:text-2xl",
          }}
          onSubmit={submitCallback}
        />
      </div>
    </section>
  )
})
